import { createStore, applyMiddleware } from 'redux';
import * as thunk from 'redux-thunk';

import rootReducer from '../reducers';
import { IUser } from './user.entity';
import { Document } from './document.entity';
import { Category } from './category.entity';

export interface Store {
    auth: {
        state: number;
        error: string;
        user: IUser;
    };
    embeddedDocs: {
        documents: {
            [key: string]: string;
        };
        isFetching: boolean;
        loaded: boolean;
        error: string;
    };
    downloads: {
        page: number;
        total: number;
        limit: number;
        items: Array<Document>;
        isFetching: boolean;
        loaded: boolean;
        error: string;
    };
    subscription: {
        page: number;
        total: number;
        limit: number;
        items: Array<Document>;
        isFetching: boolean;
        loaded: boolean;
        error: string;
    };
    categories: {
        page: number;
        total: number;
        limit: number;
        items: Array<Category>;
        isFetching: boolean;
        loaded: boolean;
        error: string;
    };
    categoryArticles: {
        page: number;
        limit: number;
        activeCategory: string;
        categories: {
            [key: string]: {
                items: Array<Document>;
                total: number;
            };
        };
        isFetching: boolean;
        loaded: boolean;
        error: string;
    };
    mobileMenuOpen: boolean;
}

export default function store(initialState: object) {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunk.default)
    );
}



// WEBPACK FOOTER //
// ./src/store/index.ts